import {
    type FlexStyle,
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    SheetFooterDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import type {
    SheetFooterAlign
} from "../../type";

export const SHEET_FOOTER_JUSTIFICATIONS: Record<SheetFooterAlign, FlexStyle["justifyContent"]> = {
    between: "space-between",
    stretch: "flex-start",
    end: "flex-end"
};

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        flexShrink: 0
    },
    stretched: {
        flexBasis: 0,
        flexGrow: 1
    }
});

export const useStyles = ({
    borders,
    colors,
    spaces,
    align,
    form
}: SheetFooterDynamicStyleType) => {
    const styles = {
        container: {
            justifyContent: SHEET_FOOTER_JUSTIFICATIONS[align],
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(form === "panel") {
        Object.assign(styles.container, {
            borderTopColor: colors.content.border.subtle,
            paddingHorizontal: spaces.spacingLg,
            borderTopWidth: borders.separator,
            paddingBottom: spaces.spacingLg,
            paddingTop: spaces.spacingMd
        });
    }

    return styles;
};
export default stylesheet;
